import type { FC, PropsWithChildren } from 'react';
import { SkeletonLine, Spinner } from '@george-labs.com/design-system';
import type { FOCUS_PAGE_SIZE } from '@george-labs.com/design-system/types/components/Page/FocusPage';

import { DetailPage } from '@shared/focus-page-ui';
import { useGlobalColor } from '@shared/core-ui-layout';

import { ProductInfoSkeleton } from './ProductInfoSkeleton';

interface Props {
    size?: FOCUS_PAGE_SIZE;
    'data-cy'?: string;
}

export const DetailPageSkeleton: FC<PropsWithChildren<Props>> = ({
    size,
    'data-cy': dataCy,
    children = <Spinner />,
}) => {
    const { value: globalColor } = useGlobalColor();

    return (
        <DetailPage
            size={size}
            data-cy={dataCy}
            color={globalColor}
            left={<ProductInfoSkeleton />}
            title={<SkeletonLine level={2} animated percentageWidth={50} className="m-auto pt-0" />}
        >
            {children}
        </DetailPage>
    );
};
